import { prefix } from '@goldwasserexchange/react-topmodel';
export var textSnippetPrefixer = prefix('TextSnippet');
